import { exists, nay } from '@/helpers'
import { A } from '@mobily/ts-belt'
import {
  PriceSettingsPaymentMethod,
  type FormattedPriceSettings,
  type PurchaseInfo,
} from '@setplex/tria-api'

// TODO: should be moved to shared?
// TODO: merge with 'price-settings.ts'
// I made it separate file because it is very hard to understand what is going on there, it looks like mess

type PartialNullable<T> = {
  [K in keyof T]?: T[K] | null | undefined
}

export type PayableEntity = PartialNullable<{
  free: boolean
  purchaseInfo: PurchaseInfo
  priceSettings: FormattedPriceSettings[]
  tvShowPriceSettings: FormattedPriceSettings[]
  seasonPriceSettings: FormattedPriceSettings[]
  episodePriceSettings: FormattedPriceSettings[]
}>

// helper function to check if entity is free
export const isFree = (entity?: PayableEntity): boolean =>
  exists(entity) && (entity.free || exists(entity.purchaseInfo))

// helper function to check if entity is paid
export const isPaid = (entity?: PayableEntity): boolean =>
  exists(entity) && nay(entity.free) && nay(exists(entity.purchaseInfo))

// helper function to check if any price setting is per set
export const anyPerSet = A.any(
  ({ paymentMethod }: FormattedPriceSettings) =>
    paymentMethod === PriceSettingsPaymentMethod.PerSet
)

// helper function to check if common price setting is per set
export const hasCommonPerSet = ({ priceSettings }: PayableEntity = {}) =>
  priceSettings != null && priceSettings.length > 0 && anyPerSet(priceSettings)

// helper function to check if episode / show price setting is per set
export const hasTvShowPerSet = ({ tvShowPriceSettings }: PayableEntity = {}) =>
  tvShowPriceSettings != null &&
  tvShowPriceSettings.length > 0 &&
  anyPerSet(tvShowPriceSettings)

// helper function to check if episode / season price setting is per set
export const hasSeasonPerSet = ({ seasonPriceSettings }: PayableEntity = {}) =>
  seasonPriceSettings != null &&
  seasonPriceSettings.length > 0 &&
  anyPerSet(seasonPriceSettings)

// helper function to check if episode / episode price setting is per set
export const hasEpisodePerSet = ({
  episodePriceSettings,
}: PayableEntity = {}) =>
  episodePriceSettings != null &&
  episodePriceSettings.length > 0 &&
  anyPerSet(episodePriceSettings)

// helper function to check if any price setting is per set
export const hasPerSet = (entity: PayableEntity = {}) =>
  hasCommonPerSet(entity) ||
  hasTvShowPerSet(entity) ||
  hasSeasonPerSet(entity) ||
  hasEpisodePerSet(entity)
